module.exports = __webpack_public_path__ + "media/images/close-alt-1fab0de549da21638589fdfd08f1930b.svg";